import React from 'react'
import { Link } from 'react-router-dom'

const AffilateHeader = ({ setShare }) => {
  const pathname = window.location.pathname

  return (
    <nav className="affiliate_header">
      <Link
        to="/affiliate/dashboard"
        className={`router-link-active router-link-exact-active ${
          pathname === '/affiliate/dashboard' ? 'active' : ''
        }`}
      >
        <span>Dashboard</span>
      </Link>
      <Link
        className={`router-link-active router-link-exact-active ${
          pathname === '/affiliate/users-list' ? 'active' : ''
        }`}
        to="/affiliate/users-list"
      >
        <span>User List</span>
      </Link>
      <Link
        to="#ShareAffiliate"
        className={`router-link-active router-link-exact-active ${
          pathname === '/affiliate/ShareAffiliate' ? 'active' : ''
        }`}
        onClick={() => setShare(true)}
      >
        <span>Share</span>
      </Link>
      <Link
        to="/affiliate/profit-loss"
        className={`router-link-active router-link-exact-active ${
          pathname?.includes('affiliate/profit-loss') ? 'active' : ''
        }`}
      >
        <span>Profit/Loss</span>
      </Link>
      <Link
        to="/affiliate/reports"
        className={`router-link-active router-link-exact-active ${
          pathname?.includes('affiliate/reports') ? 'active' : ''
        }`}
      >
        <span>Reports</span>
      </Link>
    </nav>
  )
}

export default AffilateHeader
